var _rect, _path, _circle, _path2, _path3, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPhysical(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 14,
    rx: 2,
    transform: "matrix(-0.631724 -0.775193 -0.775193 0.631724 21.3789 15.3008)",
    fill: "#BDD9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0001 31.7002C16.8543 29.6419 17.5007 24.2002 17.5007 24.2002H23.0001C23 27.2232 25.5702 27.676 27.2574 27.2852C27.99 27.1155 28.9199 27.18 29.4151 27.7459L30.9466 29.4962C31.4898 30.1171 31.3155 31.0617 30.5462 31.3598C28.6658 32.0884 25.2455 32.9984 22.0001 31.7002Z",
    fill: "#BDD9FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    transform: "matrix(1 0 0 -1 14.5137 11.4624)",
    fill: "#5AA0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4016 23.5477C16.4786 24.428 17.2546 25.0792 18.1349 25.0022L21.9205 24.671C22.8008 24.5939 23.4519 23.8179 23.3749 22.9376L22.7049 15.279C22.5364 13.3534 20.8388 11.9289 18.9132 12.0974C16.9875 12.2658 15.5631 13.9635 15.7315 15.8891L16.4016 23.5477Z",
    fill: "#5AA0FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6417 24.4503C23.0319 23.6399 22.4414 22.7002 21.542 22.7002H18.8252C17.6999 22.7002 16.674 23.3448 16.1858 24.3588L11.327 34.4501C10.9368 35.2605 11.5274 36.2002 12.4268 36.2002H15.1435C16.2689 36.2002 17.2948 35.5555 17.783 34.5416L22.6417 24.4503Z",
    fill: "#5AA0FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 14,
    rx: 2,
    transform: "matrix(0.547175 -0.837018 -0.837018 -0.547175 28.7188 23.2085)",
    fill: "#BDD9FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhysical);
export default __webpack_public_path__ + "static/media/ic_physical.12e09b7b8e7129bcf1e444fcf79f6613.svg";
export { ForwardRef as ReactComponent };